// ═══════════════════════════════════════════════════════════════
// Administration — Layout with grouped sub-navigation
// Directory section: People, Households, Facilities, Organizations, Resources, Pay Codes
// System section: Roles, Users, Activity Log, Dashboard Config
// ═══════════════════════════════════════════════════════════════

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconUsers, IconHome, IconBuildingSkyscraper, IconBuilding, IconBuildingStore,
  IconShieldCog, IconHistory,
  IconLayoutDashboard, IconSettings, IconHomeSearch,
} from '@tabler/icons-react';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import ModuleNav from '../../components/layout/ModuleNav';
import type { NavItem } from '../../types/nav';

const DIRECTORY_ITEMS: NavItem[] = [
  { label: 'People',              path: '/admin/people',        icon: IconUsers },
  { label: 'Households',          path: '/admin/households',    icon: IconHome },
  { label: 'Community Facilities',path: '/admin/facilities',    icon: IconBuilding },
  { label: 'Organizations',       path: '/admin/organizations', icon: IconBuildingSkyscraper },
  { label: 'Businesses',          path: '/admin/businesses',    icon: IconBuildingStore },
];

const SYSTEM_ITEMS: NavItem[] = [
  { label: 'Roles & Permissions', path: '/admin/system/roles',     icon: IconShieldCog, exact: true },
  { label: 'Users',               path: '/admin/system/users',     icon: IconUsers },
  { label: 'Activity Log',        path: '/admin/system/activity',  icon: IconHistory },
  { label: 'Dashboard Config',    path: '/admin/system/dashboard', icon: IconLayoutDashboard },
  { label: 'IA Configuration',    path: '/admin/system/ia-config', icon: IconHomeSearch },
];


const LABEL_MAP: Record<string, string> = {
  '/admin/people':             'People',
  '/admin/households':         'Households',
  '/admin/facilities':         'Community Facilities',
  '/admin/organizations':      'Organizations',
  '/admin/businesses':         'Businesses',
  '/admin/system/roles':       'Roles & Permissions',
  '/admin/system/users':       'Users',
  '/admin/system/activity':    'Activity Log',
  '/admin/system/dashboard':   'Dashboard Config',
  '/admin/system/ia-config':   'IA Configuration',
  '/admin/analytics':          'Analytics',
  '/admin/reports':            'Reports',
  '/admin/tl-codes':           'T&L Code Config',
};

export default function AdminLayout() {
  const { pathname } = useLocation();

  const currentLabel = Object.entries(LABEL_MAP)
    .find(([path]) => pathname === path || pathname.startsWith(path + '/'))
    ?.[1] ?? 'Administration';

  return (
    <div style={{ padding: '24px', maxWidth: 1400 }}>
      <Breadcrumbs
        items={[
          { label: 'Hub', to: '/' },
          { label: 'Administration', to: '/admin/people' },
          ...(currentLabel !== 'Administration' ? [{ label: currentLabel }] : []),
        ]}
      />
      <ModuleNav
        groups={[
          { label: '',       items: DIRECTORY_ITEMS },
          { label: 'System', items: SYSTEM_ITEMS    },
        ]}
        accentColor={brand.blurple}
      />
      <Outlet />
    </div>
  );
}
